import { collectConsent, updateConsent } from '../consent-hub';
import { CONSENT_KEYS, CONSENT_SOURCE_PARTNER_PURCHASE_CENTER, TERMS_AND_CONDITIONS_TEXT } from '../constants';

// eslint-disable-next-line
type Handler = (...args: any[]) => any;

export const useConsentHub = () => {
  const getConsent = async () => {
    const response = await collectConsent();
    return response;
  };

  const updateCustomerConsent = async (displayedText: string = TERMS_AND_CONDITIONS_TEXT) => {
    await updateConsent({
      source: CONSENT_SOURCE_PARTNER_PURCHASE_CENTER,
      consentKeys: CONSENT_KEYS,
      displayedText,
    });
  };

  const handleWithCustomerConsent = <T extends Handler>(handler: T, displayedText?: string) => {
    // @ts-ignore
    return async (...args: Parameters<T>): ReturnType<T> => {
      await updateCustomerConsent(displayedText);
      return handler(...args);
    };
  };

  return {
    getConsent,
    updateCustomerConsent,
    handleWithCustomerConsent,
  };
};
